(function ($) {
    var currentConferencePage = 1;
    var conferenceAjax = null;
    var ajaxTimeout = null;
    var filters = [];
    var template = $('#js-conference-item').html();
    var templatelist = $('#js-conference-item-list').html();
    var infoCount = $('#conference-count');

    var loadConference = function () {
        var $loader = $('.js-conference-loader');
        var $list = $('.js-conference-list');
        var $list2 = $('.js-conference-list2');
        var $loadMore = $('.js-conference-next-page');

        Mustache.parse(template);
        Mustache.parse(templatelist);

        var data = {
            page: currentConferencePage,
            nonce: rissb_var.nonces.get_conference,
        };

        if (window.matchMedia('(max-width: 768px)').matches) {
            data.filters = $('.filter-mobile .js-conference-filters :input').serialize();
        } else {
            data.filters = $('.js-conference-year-filter:checkbox:checked, .js-central-category-filter:checkbox:checked, .js-central-category-filter:checkbox:checked').serialize();
        }

        data.searchString = $('#search-conference').val();
        data.sort = $('input[name="sort[]"]').serialize();

        if (data.page == 1) {
            $loader.removeClass('d-none');
            $list.empty();
            $list2.empty();
        }

        if (conferenceAjax) {
            conferenceAjax.abort();
        }

        conferenceAjax = $.post('/api/conference', data, function (res) {
            var rendered = Mustache.render(template, res.data);

            var rendered2 = Mustache.render(templatelist, res.data);

            $loader.addClass('d-none');

            // List rendering
            $list.html(rendered);

            $list2.html(rendered2);

            $(rendered).imagesLoaded(function () {
                $.fn.matchHeight._apply('[data-mh="card-conference"]');
            });

            $(rendered2).imagesLoaded(function () {
                $.fn.matchHeight._apply('[data-mh="card-conference"]');
            });

            // Pagination
            generatePagination(res.data.pagination);

            // Update count
            infoCount.text(res.data.data.length);

        }).always(function () {
            $loadMore.text($loadMore.data('text-original'));
        });
    };

    var generatePagination = function (pagination) {

        var pages = '';
        for (var index = 1; index <= pagination.total; index++) {
            if (pagination.current === index) {
                pages += '<li class="page-item list-inline-item"><a class="page-link active" href="#' + index + '">' + index + '</a></li>';
            }
            else {
                pages += '<li class="page-item list-inline-item"><a class="page-link" href="#' + index + '">' + index + '</a></li>';
            }
        }

        var listElement = '<ul class="pagination list-inline list-unstyled text-center">' +
            '<li class="page-item list-inline-item"><a class="page-link" href="#prev"><i class="fas text-secondary fa-arrow-left"></i></a></li>' +
            pages +
            '<li class="page-item list-inline-item"><a class="page-link" href="#next"><i class="fas text-secondary fa-arrow-right"></i></a></li>' +
            '</ul>';

        $('#conference-pagination').html(listElement);
    };

    $(document).ready(function () {
        $( "#show-list" ).click(function() {
          $('.js-conference-list').hide();
          $('.js-conference-list2').show();
        });

        $( "#show-grid" ).click(function() {
          $('.js-conference-list').show();
          $('.js-conference-list2').hide();
        });

        if ($('body').hasClass('post-type-archive-conference')) {
            RISSB.fn.clearDropdownFilter(function () {
                currentConferencePage = 1;
                loadConference();
            });

            if ($('.js-conference-list').length) {
                currentConferencePage = 1;
                loadConference();
            }

            $('.js-conference-year-filter, .js-central-category-filter, .js-central-category-filter').on('change', function (evt) {
                loadConference();
            });

            $('input[name="sort[]"]').on('change', function (evt) {
                loadConference();
            });

            $(document).on('click', '.page-link', function (evt) {
                var selectedPage = $(this).attr('href').replace('#', '');

                if (selectedPage === 'prev') {
                    currentConferencePage--;
                }
                else if (selectedPage === 'next') {
                    currentConferencePage++;
                }
                else {
                    currentConferencePage = selectedPage;
                }

                loadConference();
            });

            $('.js-search-submit').on('click', function (evt) {
                evt.preventDefault();

                loadConference();
            })

            $('.js-conference-filters').find('.js-conference-search').on('keyup input', function () {
                currentConferencePage = 1;

                clearTimeout(ajaxTimeout);
                ajaxTimeout = setTimeout(loadConference, 500);
            });

            $('.js-update-filter').on('click', function () {
                var $this = $(this);
                currentConferencePage = 1;

                RISSB.fn.updateQSParams('news_categories[]', $this.closest('.js-conference-filters').find('input[name="news_categories[]"]:checked').map(function () {
                    return $(this).val();
                }).get(), true);

                loadConference();
                $this.closest('.dropdown-menu').removeClass('show');
            });

            $('.js-conference-next-page').on('click', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentConferencePage = currentConferencePage + 1;

                $this.html('<i class="fas fa-spinner fa-spin fa-fw"></i> ' + $this.data('text-progress'));
                loadConference();
            });

            $('.js-conference-list').on('click', '.js-filter-category', function (e) {
                e.preventDefault();

                var $this = $(this);

                $('.js-dropdown-filter-category').find('[type="checkbox"][name="news_categories[]"]').prop('checked', false);
                $('.js-dropdown-filter-category').find('[type="checkbox"][name="news_categories[]"][value="' + $this.data('id') + '"]').prop('checked', true).change();
                RISSB.fn.updateQSParams('news_categories[]', $this.data('id'));

                currentConferencePage = 1;

                loadConference();
            });

            $('.js-dropdown-sort').on('click', '.dropdown-item', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentConferencePage = 1;

                $('[name="orderby"]').val($this.data('orderby'));
                $('[name="order"]').val($this.data('order'));
                $('.js-order-type').text($this.text());

                loadConference();
            });

            $('.js-conference-list').on('click', '.card-news-style-1, .card-news-style-2', function (e) {
                if ($(e.target).hasClass('js-filter-category')) {
                    return;
                }

                window.location = $(this).find('.card-news-read-more').attr('href');
            });
        }

        if ($('body').hasClass('single-news')) {
            $('.is-sticky').stick_in_parent({
                offset_top: $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0,
            });

            $content = $('.post-content');

            if ($content.find('iframe').length) {
                var contentSelector = 'div.header, .layout, .one-col .column';

                $content.find('iframe').each(function () {
                    var $iframe = $(this);

                    $iframe.removeAttr('width');
                    $iframe.css('width', '100%');
                });
            }
        }
    });
})(jQuery);
